<div class="newline-converted-textarea">
    <div class="full-modal-config__form-control-row newline-converted-textarea__no-margin-top">
        <div class="full-modal-config__form-control newline-converted-textarea__form-control">
            <avi-textarea-container>
                <label
                    aviLabelWithTooltip
                    objectType="{{ objectType }}"
                    fieldName="{{ fieldName }}"
                    for="{{ name }}"
                    [required]="required"
                >
                    {{ l10nKeys.userInputLabel | vtranslate }}
                </label>
                <textarea
                    clrTextarea
                    id="{{ name }}"
                    name="{{ name }}"
                    class="newline-converted-textarea__textarea"
                    [(ngModel)]="viewValue"
                    (ngModelChange)="handleUserInputChange()"
                    placeholder="{{ placeholder }}"
                    [required]="required"
                    rows="9"
                    maxlength="5120"
                ></textarea>
            </avi-textarea-container>
            <div class="newline-converted-textarea__actions-wrapper">
                <button
                    (click)="copyToClipboard()"
                    class="newline-converted-textarea__action-button"
                    aviTitle="{{ globalL10nKeys.copyToClipboardLabel | vtranslate }}"
                >
                    <clr-icon
                        shape="copy-to-clipboard"
                        size="16"
                        status="info"
                    ></clr-icon>
                </button>
            </div>
        </div>
        <div class="full-modal-config__form-control newline-converted-textarea__form-control">
            <label
                aviLabelWithTooltip
                objectType="{{ objectType }}"
                fieldName="{{ fieldName }}"
                for="preview-value"
            >
                {{ l10nKeys.convertedValuePreviewLabel | vtranslate }}
            </label>
            <div
                [innerHtml]="readOnlyOutput"
                class="newline-converted-textarea__converted-value-preview"
            ></div>
            <div class="newline-converted-textarea__actions-wrapper">
                <button
                    (click)="copyToClipboard(true)"
                    class="newline-converted-textarea__action-button"
                    aviTitle="{{ globalL10nKeys.copyToClipboardLabel | vtranslate }}"
                >
                    <clr-icon
                        shape="copy-to-clipboard"
                        size="16"
                        status="info"
                    ></clr-icon>
                </button>
                <button
                    (click)="toggleReadOnlyView()"
                    class="newline-converted-textarea__action-button"
                    aviTitle="{{ (showPureModel ? l10nKeys.wordwrapTooltipText : l10nKeys.singleLineTooltipText) | vtranslate }}"
                >
                    <clr-icon
                        shape="{{ showPureModel ? 'child-arrow' : 'minus'}}"
                        size="16"
                        status="info"
                    ></clr-icon>
                </button>
            </div>
        </div>
    </div>
</div>
